import { Outlet } from 'react-router-dom';
import { SearchProvider } from '~/components/searchTable/searchControlBar/SearchContext';

export default function RegistrationsLayout() {
  return (
    <SearchProvider entity="Registration">
      <Outlet />
    </SearchProvider>
  );
}
